import { Component, OnInit } from '@angular/core';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pioneer-external-login-expired',
  templateUrl: './external-login-expired.component.html'
})
export class ExternalLoginExpiredComponent implements OnInit {

  constructor(private environment: EnvironmentConfiguration,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('redirect') !== null) {
      setTimeout(() => {
        location.href = this.environment.portalUrl + this.environment.portalLogout;
      }, this.environment.portalRedirectTimer);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/external-login-expired/external-login-expired.component.ts